import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import './Styles.css';

const Captcha = (props) => {
  const { input } = props;

  return (
    <>
      <label />
      <ReCAPTCHA
        className="g-recaptcha"
        sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
        onChange={(response) => input.onChange(response)}
      />
    </>
  );
};

export default Captcha;
